/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SearchWebpushSubscriptionsMutationRequest,
  SearchWebpushSubscriptionsMutationResponse,
} from '../types/SearchWebpushSubscriptions.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchWebpushSubscriptionsUrl() {
  const res = { method: 'POST', url: `/subscriptions/search` as const };
  return res;
}

/**
 * @summary Search webpush subscriptions
 * {@link /subscriptions/search}
 */
export async function searchWebpushSubscriptions(
  data: SearchWebpushSubscriptionsMutationRequest,
  config: Partial<RequestConfig<SearchWebpushSubscriptionsMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SearchWebpushSubscriptionsMutationResponse,
    ResponseErrorConfig<Error>,
    SearchWebpushSubscriptionsMutationRequest
  >({ method: 'POST', url: getSearchWebpushSubscriptionsUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
